import { render, staticRenderFns } from "./team-card.html?vue&type=template&id=caff1fda&scoped=true&"
import script from "./team-card.js?vue&type=script&lang=js&"
export * from "./team-card.js?vue&type=script&lang=js&"
import style0 from "./team-card.scss?vue&type=style&index=0&id=caff1fda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff1fda",
  null
  
)

export default component.exports